// Idiomas suportados. `pt-BR` é o padrão (base histórica do app).
export type Lang = 'en' | 'pt-BR' | 'es'

export const LANGS: { code: Lang; label: string }[] = [
  { code: 'pt-BR', label: 'Português (Brasil)' },
  { code: 'en', label: 'English' },
  { code: 'es', label: 'Español' },
]

export const DEFAULT_LANG: Lang = 'pt-BR'

export function isLang(v: string | null | undefined): v is Lang {
  return v === 'en' || v === 'pt-BR' || v === 'es'
}

// date-fns locale por idioma (usado onde o app formata datas/meses).
export const DATE_LOCALE: Record<Lang, string> = { en: 'en-US', 'pt-BR': 'pt-BR', es: 'es' }
